import type { PropsWithChildren, ReactNode } from 'react';

import { css } from '@compiled/react';

import { media } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';

import { JSMOverlayTemplate } from '@/components/signup/layouts/product-overlay-template';
import { ServiceCollectionLogoV2 } from '@/components/signup/utils/logos/service-collection-logo-v2';

type JsmUseCaseOnboardingContainerProps = PropsWithChildren<{
	header: string;
	subheader: string;
	isJsmCrossflow?: boolean;
	topLeftAction?: ReactNode;
}>;

export const JsmUseCaseOnboardingContainer = ({
	children,
	header,
	subheader,
	isJsmCrossflow,
	topLeftAction,
}: JsmUseCaseOnboardingContainerProps) => (
	<JSMOverlayTemplate
		header={header}
		headerLogo={<ServiceCollectionLogoV2 />}
		subheader={subheader}
		size="md"
		hideLogo
		isJsmCrossflow={isJsmCrossflow}
	>
		{topLeftAction && <div css={topLeftActionWrapperStyles}>{topLeftAction}</div>}
		{children}
	</JSMOverlayTemplate>
);

const topLeftActionWrapperStyles = css({
	position: 'absolute',
	insetBlockStart: token('space.400'),
	insetInlineStart: token('space.400'),
	marginBlockEnd: token('space.0'),
	[media.below.sm]: {
		insetBlockStart: token('space.0'),
		insetInlineStart: token('space.0'),
	},
});
